import useCurrentUser from '../hooks/useCurrentUser'

export default function useMayEditProfile(userId: string): boolean {
  const currentUser = useCurrentUser()
  return currentUser?.organizationAdmin || currentUser?.id === userId
}
